import { IntlManager } from "@apptegy/vue-intl";
import { defineNuxtPlugin } from "#app";
import { useRequestEvent } from "#imports";
import optionsLoader from "#build/nuxt-intl-i18n-options.mjs";
const getPreferredLocales = () => {
  if (process.server) {
    const event = useRequestEvent();
    const { req } = event.node;
    return (req && req.headers["accept-language"] || "").split(",").map((tag) => tag.split(";")[0].trim()).filter((code) => code !== "*");
  } else {
    return navigator && navigator.languages || [];
  }
};
export default defineNuxtPlugin(async () => {
  const {
    locales,
    defaultLocale,
    pseudoMode,
    pseudoPercentage
  } = await optionsLoader();
  const userPreferredLocales = getPreferredLocales();
  const intlManager = new IntlManager({
    locales,
    defaultLocale,
    userPreferredLocales,
    pseudoMode,
    pseudoPercentage
  });
  const intlObject = {
    intl: {},
    $t: (_) => "",
    $d: (_) => ""
  };
  const intlProxy = new Proxy(intlObject, {
    get: (target, attr) => {
      if (attr === "$setLocale") {
        return setLocale;
      }
      return Reflect.get(target.intl, attr);
    }
  });
  const setLocale = (requestedLocale, errorHandler) => {
    intlObject.intl = intlManager.createIntlWithLocale(
      requestedLocale,
      errorHandler
    );
  };
  setLocale();
  function t(...args) {
    return intlProxy.$t(...args);
  }
  function d(...args) {
    return intlProxy.$d(...args);
  }
  return {
    provide: {
      intlManager,
      intl: intlProxy,
      t,
      d
    }
  };
});
